module.exports = __webpack_public_path__ + "img/logo.3fd62b5d.svg";